





















































































































































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, reactive, SetupContext } from '@vue/composition-api';

import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import axios from 'axios';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import moment from 'moment';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Image = {
  id: string,
  name: string,
  url: string,
};

type Concept = {
	id: string,
	project_id: string,
	cp_template_id: string,
	name?: string,
	title?: string,
	description?: string,
  image_vertical_size?: number,
	topbox?: number,
	sum_of_top2box?: number,
	created_at: string,
	updated_at: string,

  concept_image_id: string,
  cpcard_image_id: string,

  project_name: string,

  cpcard_image: Image
};

type Project = {
  id: string,	
	organization_id: string,
	user_id: string,       
	name: string,         
	supplemental_memo: string,
	internal_memo: string,
  default_cp_template_id: string,
	is_archived: boolean,
	created_at: string,    
	updated_at: string,  
};

type Props = {
  id: string;
};

async function loadImage(data: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e: Event) => {
      resolve(reader.result as string);
    };
    reader.readAsDataURL(data);
  });
};

export default defineComponent({
  name: "ProjectDetail",
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    NavHeader,
    Footer
  },
  head: {
    link: [
      { rel: "stylesheet", type: "text/css", href: "/css/login/project.css" }
    ],
    script: [
         { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
         { src: "/js/toggle_contents.js" },
    ]
  },
  filters: {
    moment: function (date: string) {
      moment.locale('ja')
      return moment(date).format('YYYY/MM/DD')
    }
  },

  setup(props: Props, context: SetupContext) {
    const state = reactive({
      project: {} as Project,
      selectedConcepts: [] as Concept[],
      conceptPreview: {
        cpcard_image: { id: '', name: '', url: '/images/archive_img.png' }
      } as Concept
    });

    async function load() {
      console.log(props)
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.get('dev', '/projects/' + props.id, options).then(response => {
        console.log(response);
        state.project = response.data;
        console.log(state);
      }).catch(err => {
        console.log(err);
      });
    }
    load();

    async function deleteProject() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.del('dev', '/projects/' + props.id, options).then(response => {
        console.log(response);
        context.root.$router.push('/project');
      }).catch(err => {
        console.log(err);
      });
    }

    async function archiveProject() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.put('dev', '/projects/archives/' + props.id, options).then(response => {
        console.log(response);
        context.root.$router.push('/archive');
      }).catch(err => {
        console.log(err);
      });
    }

    async function copyProject() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.post('dev', '/projects/copy/' + props.id, options).then(response => {
        console.log(response);
        context.root.$router.push({ name: 'ProjectEditor', params: { id: response.data.id } });
      }).catch(err => {
        console.log(err);
      });
    }

    async function deleteConcept(id: string) {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.del('dev', '/concepts/' + id, options).then(response => {
        console.log(response);
        load();
      }).catch(err => {
        console.log(err);
      });
    }

    async function downloadConceptImages() {
      if (state.selectedConcepts.length === 0) return;

      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        queryStringParameters: {  // OPTIONAL
          pid: '',
          cid: ''
        }
      };

      const zip = new JSZip().folder('images');
      const cpcards = await Promise.all(state.selectedConcepts.map(async (cp: Concept) => {
        if (cp.cpcard_image_id) {
          options.queryStringParameters.pid = cp.project_id;
          options.queryStringParameters.cid = cp.id;

          return API.get('dev', '/images/cpcards/' + cp.cpcard_image_id, options);
        }
      }));

      Promise.all(cpcards.map(async (cpcard) => {
        return axios.get(cpcard.data.url, { responseType: 'blob' });
      })).then((cpimgs) => {
        cpimgs.map((v, i) => {
          zip.file(cpcards[i].data.name, v.data);
        });
        zip.generateAsync({ type: 'blob' }).then(content => {
          saveAs(content, 'images.zip')
        });
      })
    }

    async function showConcept(concept: Concept) {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        queryStringParameters: {  // OPTIONAL
          pid: '',
          cid: ''
        }
      };

      if (concept.cpcard_image_id) {
        options.queryStringParameters.pid = concept.project_id;
        options.queryStringParameters.cid = concept.id;

        const cpcard = await API.get('dev', '/images/cpcards/' + concept.cpcard_image_id, options);
        state.conceptPreview.cpcard_image = cpcard.data;

        const image = await axios.get(cpcard.data.url, { responseType: 'blob' });
        state.conceptPreview.cpcard_image.url = await loadImage(image.data);
      } else {
        state.conceptPreview.cpcard_image = { id: '', name: '', url: '/images/archive_img.png'};
      }

      context.root.$modal.show("conceptPreview");
    }


    return {
      state,

      deleteProject,
      archiveProject,
      copyProject,

      deleteConcept,
      downloadConceptImages,
      showConcept,
    };
  }

});
